export const COMPANY_INFO = {
  name: "Kærby Tømrer- & Snedkerforretning ApS",
  shortName: "Kærby Tømrer- & Snedkerforretning",
  cvr: "32474527",
  phone: "26 19 20 88",
  phoneRaw: "26192088",
  email: "snedkeren@k-t-s.dk",
  address: "Kærby Møllevej 2",
  city: "8983 Gjerlev",
  area: "Randers, Hadsund, Mariager og omegn",
  logoUrl: "https://assets.auxodev.dk/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/logo.svg",
  instagramUrl: "https://www.instagram.com/kaerbytoemreren/",
  houzzBadge: "https://assets.auxodev.dk/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/houzz.png"
};

export const NAV_ITEMS = [
  { label: "Forside", path: "/" },
  {
    label: "Ydelser",
    path: "/ydelser",
    children: [
      { label: "Tilbygning & Ombygning", path: "/tilbygning", icon: "fa-solid fa-house-building" },
      { label: "Nybyggeri", path: "/nybyggeri", icon: "fa-solid fa-person-digging" },
      { label: "Renovering & Modernisering", path: "/renovering", icon: "fa-solid fa-hammer" },
      { label: "Tagarbejde & Tagudskiftning", path: "/tagarbejde", icon: "fa-solid fa-house-chimney" },
      { label: "Døre & Vinduer", path: "/vinduer-doere", icon: "fa-solid fa-door-open" },
      { label: "Træterrasser & Uderum", path: "/terrasser", icon: "fa-solid fa-layer-group" },
      { label: "Snedkerarbejde & Inventar", path: "/snedkerarbejde", icon: "fa-solid fa-saw" },
      { label: "Isolering & Termografi", path: "/isolering", icon: "fa-solid fa-temperature-arrow-down" },
    ]
  },
  { label: "Om os", path: "/om-os" },
  { label: "Referencer", path: "/referencer" },
  { label: "Kontakt", path: "/kontakt" }
];

export const SERVICES_LIST = [
  {
    id: "tilbygning",
    title: "Tilbygning & Ombygning",
    slug: "tilbygning",
    shortDesc: "Mangler I ekstra plads i boligen? Vi tegner og opfører arkitekttegnede tilbygninger og ombygninger i højeste håndværksmæssige kvalitet.",
    icon: "fa-solid fa-house-building",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/cta-nybyg.jpg"
  },
  {
    id: "nybyggeri",
    title: "Nybyggeri",
    slug: "nybyggeri",
    shortDesc: "Drømmer I om nybygget hus eller sommerhus? Vi står for hele byggeprocessen med tryghed og garanti for præcision.",
    icon: "fa-solid fa-person-digging",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/1-syd-facade-efter-640x480-c.jpg"
  },
  {
    id: "renovering",
    title: "Renovering",
    slug: "renovering",
    shortDesc: "Gennemgribende modernisering eller fornyelse af boligen med sans for æstetik, funktion og energibesparelser.",
    icon: "fa-solid fa-hammer",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/cta-renovering.jpg"
  },
  {
    id: "tagarbejde",
    title: "Tagarbejde & Tagudskiftning",
    slug: "tagarbejde",
    shortDesc: "Nyt tag eller reparation af det eksisterende. Vi lægger tegl, eternit, stål og tagpap med tilhørende loftsisolering.",
    icon: "fa-solid fa-house-chimney",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/4-st-gavl-efter-640x480-c.jpg"
  },
  {
    id: "vinduer-doere",
    title: "Døre & Vinduer",
    slug: "vinduer-doere",
    shortDesc: "Nye lavenergi vinduer og døre. Vi opmåler og monterer præcist med snedkerfinish, der sikrer lavere varmeregning.",
    icon: "fa-solid fa-door-open",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/2-indgang-efter-640x480-c.jpg"
  },
  {
    id: "terrasser",
    title: "Træterrasser",
    slug: "terrasser",
    shortDesc: "Flotte træterrasser i hårdtræ, lærk eller imprægneret træ med skjulte skruer og solid konstruktion.",
    icon: "fa-solid fa-layer-group",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/cta-terasser.jpg"
  },
  {
    id: "snedkerarbejde",
    title: "Snedkerarbejde & Inventar",
    slug: "snedkerarbejde",
    shortDesc: "Specialfremstillede diske, butiksinventar, unika møbler og tilpassede snedkerløsninger til erhverv og private.",
    icon: "fa-solid fa-saw",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/sko-diske-1-640x480-c.jpg"
  },
  {
    id: "isolering",
    title: "Isolering & Termografi",
    slug: "isolering",
    shortDesc: "Termografisk undersøgelse og effektiv efterisolering af loft og hulmur for optimal energibesparelse.",
    icon: "fa-solid fa-temperature-arrow-down",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/kf.jpg"
  }
];

export const TESTIMONIALS = [
  {
    id: "1",
    author: "Henrik & Mette Thomsen",
    location: "Randers",
    rating: 5,
    date: "Areal: Tilbygning & nyt tag",
    text: "Kærby Tømrer- & Snedkerforretning opførte vores nye tilbygning og skiftede taget på huset. Alt forløb fuldstændig efter tidsplanen, og kvaliteten af håndværket er i top. Vi følte os i trygge hænder hele vejen."
  },
  {
    id: "2",
    author: "Klaus Mortensen",
    location: "Mariager",
    rating: 5,
    date: "Areal: Ny træterrasse i Ipé",
    text: "Vi fik bygget en stor træterrasse med niveauforskelle. Finish på samlingerne og snedkerpræcisionen er imponerende. Rigtig dygtige tømrere der rydder pænt op efter sig selv hver dag."
  },
  {
    id: "3",
    author: "Camilla Lindegaard",
    location: "Hadsund",
    rating: 5,
    date: "Areal: Døre, vinduer & isolering",
    text: "Mester kom ud og gav en god grundig rådgivning omkring lavenergivinduer og isolering. Tilbuddet holdt stik, og arbejdet blev udført utrolig hurtigt og professionelt."
  },
  {
    id: "4",
    author: "Butik & Erhverv K/S",
    location: "Randers C",
    rating: 5,
    date: "Areal: Specialfremstillet butiksinventar",
    text: "Snedkerarbejdet på vores nye salgsdiske og væginventar oversteg vores forventninger. Præcist, smukt træarbejde og stor faglig stolthed."
  }
];

export const PROJECTS_GALLERY = [
  {
    title: "Facaderenovering & Ny Entré",
    location: "Randers",
    category: "Nybyggeri & Tilbygning",
    beforeImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/1-syd-facade-f-r-640x480-c.jpg",
    afterImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/1-syd-facade-efter-640x480-c.jpg"
  },
  {
    title: "Udskiftning af Vinduer & Indgangsparti",
    location: "Mariager",
    category: "Døre & Vinduer",
    beforeImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/2-indgang-f-r-640x480-c.jpg",
    afterImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/2-indgang-efter-640x480-c.jpg"
  },
  {
    title: "Ny Beklædning & Efterisolering af Gavl",
    location: "Hadsund",
    category: "Tagarbejde & Isolering",
    beforeImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/4-st-gavl-f-r-640x480-c.jpg",
    afterImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/4-st-gavl-efter-640x480-c.jpg"
  },
  {
    title: "Eksklusiv Ipé Træterrasse",
    location: "Gjerlev",
    category: "Træterrasser",
    beforeImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/12-ipe-terrasse-640x480-c.jpg",
    afterImage: "https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/13-ipe-terrasse-640x480-c.jpg"
  }
];
